export const formatAvailableFrom = (value) => {
    if (!value) return ""
    const raw = String(value).trim()
    const datePart = raw.slice(0, 10)
    if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return ""
    const [year, month, day] = datePart.split("-").map(Number)
    const date = new Date(year, month - 1, day)
    if (Number.isNaN(date.getTime())) return ""
    const options = { day: "numeric", month: "short" }
    if (date.getFullYear() !== new Date().getFullYear()) {
        options.year = "numeric"
    }
    return date.toLocaleDateString("en-GB", options)
}

export const availabilityLabel = (available, availableFrom = null) => {
    if (available === 1) return "Available now"
    if (available === 0) {
        const when = formatAvailableFrom(availableFrom)
        return when ? `Coming soon · ${when}` : "Coming soon"
    }
    return "Unavailable"
}

export const availabilityChipSx = (available) => {
    if (available === 1) {
        return {
            bgcolor: "rgba(0, 182, 122, 0.95)",
            color: "#fff",
        }
    }
    if (available === 0) {
        return {
            bgcolor: "rgba(232, 149, 0, 0.95)",
            color: "#fff",
        }
    }
    return {
        bgcolor: "rgba(0, 4, 53, 0.75)",
        color: "#fff",
    }
}

export {
    getVehicleRegistration,
    getVehicleRegistrationDate,
    getVehicleImagesData,
    getVehicleImageUrls,
    getVehicleCoverUrl,
    getVehicleDisplayName,
    getVehicleMake,
    getVehicleModel,
    getVehicleFuel,
    getVehicleTransmission,
    getVehicleColour,
    getVehicleSeats,
    getVehicleBodyType,
    getVehicleVin,
    getVehicleYear,
    getVehicleYearPlate,
    getVehicleEngineCapacity,
    getVehicleTags,
    getVehicleLicensingAuthority,
    getHirePackages,
    getInsuranceIncluded,
    getVehiclePrice,
    vehicleOffersInsurancePackage,
    vehicleOffersUninsuredPackage,
    formatVehicleWeeklyPriceLabel,
    getVehicleAvailability,
    getVehicleMotData,
    getVehicleTaxData,
    getVehicleSpecData,
} from "./vehicleApi"
